import { render, staticRenderFns } from "./NumberBoard.vue?vue&type=template&id=63880e80&"
import script from "./NumberBoard.vue?vue&type=script&lang=js&"
export * from "./NumberBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports